// frontend/src/marketing/Logo.jsx
import React from "react";
import PropTypes from "prop-types";

/**
 * Logo — QRFlow wordmark with a small QR-glyph mark. Inline SVG so it inherits
 * sizing from `className` (set the height) and needs no asset request.
 */
export default function Logo({ className }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <svg viewBox="0 0 32 32" className="h-full w-auto" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="8" fill="#2563eb" />
        <g fill="#ffffff">
          <rect x="7" y="7" width="7" height="7" rx="1.5" />
          <rect x="18" y="7" width="7" height="7" rx="1.5" />
          <rect x="7" y="18" width="7" height="7" rx="1.5" />
          <rect x="19" y="19" width="3" height="3" rx="0.5" />
          <rect x="23" y="19" width="2" height="2" rx="0.5" />
          <rect x="19" y="23" width="2" height="2" rx="0.5" />
          <rect x="23" y="23" width="2" height="2" rx="0.5" />
        </g>
      </svg>
      <span className="text-xl font-bold tracking-tight text-gray-900">QRFlow</span>
    </span>
  );
}

Logo.propTypes = { className: PropTypes.string };
Logo.defaultProps = { className: "h-8" };
